export function EstimatedTimeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M17.003 14.002a1 1 0 10-2-.002L15 15.956 15 16c0 .276.112.526.293.707a.997.997 0 00.75.293H18a1 1 0 000-2h-.998v-.998z"
      ></path>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M9 4a1 1 0 00-2 0v1H6a3 3 0 00-3 3v10a3 3 0 003 3h6.682A6 6 0 0021 12.682V8a3 3 0 00-3-3h-1V4a1 1 0 10-2 0v1H9V4zm2.528 8A5.978 5.978 0 0010 16c0 1.093.292 2.117.803 3H6a1 1 0 01-1-1v-6h6.528zM16 12a4 4 0 100 8 4 4 0 000-8zm3-2V8a1 1 0 00-1-1h-1v1a1 1 0 11-2 0V7H9v1a1 1 0 01-2 0V7H6a1 1 0 00-1 1v2h14z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
